// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"291":"c9a8b8d5055f705bd308","825":"29203a225e88524b9cba"}[chunkId] + ".js";
};